(() => {
  let luxuryObserver = null;
  let introObserver = null;
  let resizeTimer = null;
  let cinematicGsapCompleteHandler = null;
  let currentIndex = 0;
  let animating = false;
  let footerVisible = false;
  let introActive = false;
  let luxuryAnchorHandler = null;
  let pendingLuxuryHash = window.location.hash || null;
  let navigateLuxuryHash = null;

  const HEADER_HEIGHT = 49;

  function getSections() {
    return gsap.utils.toArray("[data-luxury-fold]");
  }

  function getFooter() {
    return document.querySelector("[data-luxury-footer]");
  }

  function getSamePageHash(href) {
  if (!href || !href.includes("#")) return null;

  const url = new URL(href, window.location.href);

  const currentPath = window.location.pathname.replace(/\/$/, "");
  const linkPath = url.pathname.replace(/\/$/, "");

  if (url.origin !== window.location.origin) return null;
  if (linkPath !== currentPath) return null;

  return url.hash || null;
}

function getHashTarget(hash) {
  if (!hash) return null;

  const id = decodeURIComponent(hash.replace("#", ""));
  return document.getElementById(id);
}

function bindLuxuryAnchorLinks(sections) {
  if (luxuryAnchorHandler) {
    document.removeEventListener("click", luxuryAnchorHandler);
  }

  luxuryAnchorHandler = function (e) {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const hash = getSamePageHash(link.getAttribute("href"));
    if (!hash) return;

    const target = getHashTarget(hash);
    if (!target) return;

    e.preventDefault();

    pendingLuxuryHash = hash;
    history.pushState(null, "", hash);

    if (introActive) {
      activateLuxuryScroll(sections, true);
      return;
    }

    if (navigateLuxuryHash) {
      navigateLuxuryHash(hash);
    }
  };

  document.addEventListener("click", luxuryAnchorHandler);
}

  function getIntroSlider() {
    return document.querySelector("[data-cinematic-manifesto-slider]");
  }

  function getCinematicGsapIntro() {
    return document.querySelector("[data-cinematic-manifesto-gsap]");
  }

  function getActiveIntro() {
    return getCinematicGsapIntro() || getIntroSlider();
  }

  function killObservers() {
    if (luxuryObserver) {
      luxuryObserver.kill();
      luxuryObserver = null;
    }

    if (introObserver) {
      introObserver.kill();
      introObserver = null;
    }
  }

  function clearCinematicGsapCompleteListener() {
    if (!cinematicGsapCompleteHandler) return;

    document.removeEventListener(
      "cinematicManifestoComplete",
      cinematicGsapCompleteHandler
    );

    cinematicGsapCompleteHandler = null;
  }

  function setHeaderHeight() {
    document.documentElement.style.setProperty(
      "--luxury-header-height",
      `${HEADER_HEIGHT}px`
    );
  }

  function showIntroSlider() {
    const intro = getActiveIntro();

    if (!intro) return;

    gsap.set(intro, {
      autoAlpha: 1,
      visibility: "visible",
      pointerEvents: "auto",
      zIndex: 0
    });
  }

  function hideIntroSlider() {
    const intro = getActiveIntro();

    if (!intro) return;

    gsap.set(intro, {
      autoAlpha: 0,
      visibility: "hidden",
      pointerEvents: "none",
      zIndex: 0
    });
  }

  function resetSectionStyles(sections) {
    sections.forEach((section, index) => {
      section.classList.toggle("is-first-luxury-fold", index === 0);

      gsap.set(section, {
        position: "relative",
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        inset: "auto",
        width: "100%",
        height: "auto",
        zIndex: "auto",
        y: 0,
        yPercent: 0,
        xPercent: 0,
        autoAlpha: 1,
        opacity: 1,
        visibility: "visible",
        overflow: "visible",
        clearProps: "transform"
      });
    });
  }

  function resetFooterStyles() {
    const footer = getFooter();

    if (!footer) return;

    gsap.set(footer, {
      position: "relative",
      top: "auto",
      left: "auto",
      right: "auto",
      bottom: "auto",
      inset: "auto",
      width: "100%",
      height: "auto",
      maxHeight: "none",
      zIndex: "auto",
      y: 0,
      yPercent: 0,
      autoAlpha: 1,
      opacity: 1,
      visibility: "visible",
      overflow: "visible",
      clearProps: "transform"
    });
  }

  function resetTextStyles() {
    gsap.set("[data-luxury-text] > *", {
      opacity: 1,
      y: 0,
      clearProps: "transform"
    });
  }

  function resetForMobile(sections) {
    killObservers();
    clearCinematicGsapCompleteListener();

    document.body.classList.remove("luxury-scroll-active");
    gsap.killTweensOf(sections);

    showIntroSlider();
    resetSectionStyles(sections);
    resetFooterStyles();
    resetTextStyles();

    footerVisible = false;
    introActive = false;
    currentIndex = 0;
    animating = false;
  }

  function animateContent(section) {
    // The homepage hero has its own entrance; don't hide it a second time.
    if (document.documentElement.classList.contains("eden-homepage") &&
        section.matches(".sec-one")) return;
    const textItems = section.querySelectorAll("[data-luxury-text] > *");

    if (textItems.length) {
      gsap.fromTo(
        textItems,
        {
          opacity: 0,
          y: 14
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.1,
          ease: "power2.out"
        }
      );
    }
  }

  function setupIntroLanding(sections) {
    killObservers();
    clearCinematicGsapCompleteListener();

    introActive = true;
    footerVisible = false;
    currentIndex = 0;
    animating = false;

    document.body.classList.remove("luxury-scroll-active");

    gsap.killTweensOf(sections);

    showIntroSlider();
    resetSectionStyles(sections);
    resetFooterStyles();
    resetTextStyles();

    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });

    introObserver = Observer.create({
      target: window,
      type: "wheel,touch",
      preventDefault: true,
      tolerance: 12,
      wheelSpeed: -1,

      onUp: () => {
        if (animating) return;
        activateLuxuryScroll(sections, true);
      },

      onDown: () => {
        if (animating) return;
        window.scrollTo(0, 0);
      }
    });
  }

  function setupCinematicGsapLanding(sections) {
    killObservers();
    clearCinematicGsapCompleteListener();

    introActive = true;
    footerVisible = false;
    currentIndex = 0;
    animating = false;

    document.body.classList.remove("luxury-scroll-active");

    gsap.killTweensOf(sections);

    showIntroSlider();
    resetSectionStyles(sections);
    resetFooterStyles();
    resetTextStyles();

    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });

    cinematicGsapCompleteHandler = function () {
      cinematicGsapCompleteHandler = null;
      activateLuxuryScroll(sections, true);
    };

    document.addEventListener(
      "cinematicManifestoComplete",
      cinematicGsapCompleteHandler,
      { once: true }
    );
  }

  function activateLuxuryScroll(sections, fromIntro) {
    const footer = getFooter();

    if (introObserver) {
      introObserver.kill();
      introObserver = null;
    }

    clearCinematicGsapCompleteListener();

    introActive = false;
    footerVisible = false;
    currentIndex = 0;
    animating = false;

    document.body.classList.add("luxury-scroll-active");

    gsap.killTweensOf(sections);

    window.scrollTo(0, 0);

    sections.forEach((section, index) => {
      section.classList.toggle("is-first-luxury-fold", index === 0);

      gsap.set(section, {
        position: "fixed",
        top: HEADER_HEIGHT,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: `calc(100svh - ${HEADER_HEIGHT}px)`,
        overflow: "hidden",
        zIndex: index === 0 ? 2 : 1,
        y: 0,
        yPercent: index === 0 ? 0 : 100,
        autoAlpha: index === 0 ? 1 : 0,
        visibility: index === 0 ? "visible" : "hidden"
      });
    });

    if (footer) {
      gsap.set(footer, {
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        maxHeight: `calc(100svh - ${HEADER_HEIGHT}px)`,
        overflowY: "auto",
        zIndex: 4,
        yPercent: 100,
        autoAlpha: 0,
        visibility: "hidden"
      });
    }

    if (luxuryObserver) {
      luxuryObserver.kill();
      luxuryObserver = null;
    }

    function goToSection(index, direction) {
      if (animating) return;
      if (footerVisible) return;
      if (index < 0 || index >= sections.length) return;
      if (index === currentIndex) return;

      animating = true;

      const currentSection = sections[currentIndex];
      const nextSection = sections[index];

      gsap.timeline({
        defaults: {
          ease: "power3.inOut"
        },
        onStart: () => {
          gsap.set(nextSection, {
            visibility: "visible",
            autoAlpha: 1,
            zIndex: 3,
            y: 0,
            yPercent: direction > 0 ? 100 : -100
          });

          gsap.set(currentSection, {
            zIndex: 2
          });
        },
        onComplete: () => {
          gsap.set(currentSection, {
            autoAlpha: 0,
            visibility: "hidden",
            zIndex: 1,
            y: 0
          });

          gsap.set(nextSection, {
            autoAlpha: 1,
            visibility: "visible",
            zIndex: 2,
            y: 0,
            yPercent: 0
          });

          currentIndex = index;
          animating = false;
          animateContent(nextSection);
        }
      })
        .to(
          currentSection,
          {
            yPercent: direction > 0 ? -22 : 22,
            autoAlpha: 0,
            duration: 1.05
          },
          0
        )
        .to(
          nextSection,
          {
            yPercent: 0,
            duration: 1.05
          },
          0
        );
    }

  function returnToIntro() {
    const intro = getActiveIntro();
    const cinematicGsapIntro = getCinematicGsapIntro();

    if (!intro || animating) return;

    animating = true;

    const currentSection = sections[currentIndex];

    showIntroSlider();

    gsap.set(intro, {
      autoAlpha: 1,
      visibility: "visible",
      pointerEvents: "auto",
      zIndex: 0
    });

    gsap.set(currentSection, {
      zIndex: 3
    });

    gsap.timeline({
      defaults: {
        ease: "power3.inOut"
      },
      onComplete: () => {
        document.body.classList.remove("luxury-scroll-active");

        resetSectionStyles(sections);
        resetFooterStyles();
        resetTextStyles();

        showIntroSlider();

        currentIndex = 0;
        footerVisible = false;
        animating = false;
        introActive = true;

        requestAnimationFrame(() => {
          window.scrollTo(0, 0);

          if (cinematicGsapIntro) {
            document.dispatchEvent(
              new CustomEvent("cinematicManifestoReset", {
                detail: {
                  sectionId: cinematicGsapIntro.id
                }
              })
            );

            setupCinematicGsapLanding(sections);
          } else {
            setupIntroLanding(sections);
          }
        });
      }
    }).to(currentSection, {
      yPercent: 100,
      autoAlpha: 0,
      duration: 1.05
    });
  }

    function showFooter() {
      if (!footer || footerVisible || animating) return;

      animating = true;

      const currentSection = sections[currentIndex];

      gsap.timeline({
        defaults: {
          ease: "power3.inOut"
        },
        onStart: () => {
          gsap.set(footer, {
            visibility: "visible",
            autoAlpha: 1,
            yPercent: 100
          });

          gsap.set(currentSection, {
            zIndex: 2
          });
        },
        onComplete: () => {
          footerVisible = true;
          animating = false;
        }
      })
        .to(
          currentSection,
          {
            y: -70,
            duration: 1.05
          },
          0
        )
        .to(
          footer,
          {
            yPercent: 0,
            duration: 1.05
          },
          0
        );
    }

    function hideFooter() {
      if (!footer || !footerVisible || animating) return;

      animating = true;

      const currentSection = sections[currentIndex];

      gsap.timeline({
        defaults: {
          ease: "power3.inOut"
        },
        onComplete: () => {
          gsap.set(footer, {
            autoAlpha: 0,
            visibility: "hidden",
            yPercent: 100
          });

          footerVisible = false;
          animating = false;
        }
      })
        .to(
          footer,
          {
            yPercent: 100,
            duration: 1.05
          },
          0
        )
        .to(
          currentSection,
          {
            y: 0,
            duration: 1.05
          },
          0
        );
    }

    navigateLuxuryHash = function (hash) {
  const target = getHashTarget(hash);
  if (!target) return;

  const targetSection = target.closest("[data-luxury-fold]");

  if (targetSection) {
    const targetIndex = sections.indexOf(targetSection);

    if (targetIndex !== -1) {
      goToSection(targetIndex, targetIndex > currentIndex ? 1 : -1);
    }

    return;
  }

  if (footer && (target === footer || footer.contains(target))) {
    const lastIndex = sections.length - 1;

    if (currentIndex !== lastIndex) {
      goToSection(lastIndex, lastIndex > currentIndex ? 1 : -1);

      setTimeout(() => {
        showFooter();
      }, 1150);
    } else {
      showFooter();
    }
  }
};

function runPendingLuxuryHash() {
  if (!pendingLuxuryHash || !navigateLuxuryHash) return;

  const hash = pendingLuxuryHash;
  pendingLuxuryHash = null;

  requestAnimationFrame(() => {
    navigateLuxuryHash(hash);
  });
}

    luxuryObserver = Observer.create({
      target: window,
      type: "wheel,touch",
      preventDefault: true,
      tolerance: 12,
      wheelSpeed: -1,

      onDown: () => {
        if (footerVisible) {
          hideFooter();
          return;
        }

        if (currentIndex === 0 && getActiveIntro()) {
          returnToIntro();
          return;
        }

        goToSection(currentIndex - 1, -1);
      },

      onUp: () => {
        if (footerVisible) return;

        if (currentIndex === sections.length - 1 && footer) {
          showFooter();
          return;
        }

        goToSection(currentIndex + 1, 1);
      }
    });

    requestAnimationFrame(() => {
      gsap.set(sections[0], {
        autoAlpha: 1,
        visibility: "visible",
        y: 0,
        yPercent: fromIntro ? 100 : 0,
        zIndex: 2
      });

      if (fromIntro) {
        gsap.to(sections[0], {
          yPercent: 0,
          duration: 1.05,
          ease: "power3.inOut",
          onComplete: () => {
  hideIntroSlider();
  animateContent(sections[0]);
  runPendingLuxuryHash();
}
        });
      } else {
        hideIntroSlider();
animateContent(sections[0]);
runPendingLuxuryHash();
      }
    });
  }

  function initLuxuryScroll() {
    if (!window.gsap || !window.Observer) {
      console.warn("GSAP or Observer is not loaded.");
      return;
    }

    gsap.registerPlugin(Observer);
    setHeaderHeight();

    const sections = getSections();
    if (!sections.length) return;

    const isMobile = window.matchMedia("(max-width: 989px)").matches;

    if (isMobile) {
      if ((document.documentElement.classList.contains("eden-homepage") ||
           document.documentElement.classList.contains("eden-product-page")) &&
          !document.body.classList.contains("luxury-scroll-active") && !introActive) {
        // The homepage's initial mobile layout is already supplied by CSS.
        killObservers();
        return;
      }
      resetForMobile(sections);
      return;
    }

    bindLuxuryAnchorLinks(sections);

    const cinematicGsapIntro = getCinematicGsapIntro();
    const introSlider = getIntroSlider();

    if (cinematicGsapIntro) {
      setupCinematicGsapLanding(sections);
      return;
    }

    if (introSlider) {
      setupIntroLanding(sections);
      return;
    }

    hideIntroSlider();
    activateLuxuryScroll(sections, false);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initLuxuryScroll);
  } else {
    initLuxuryScroll();
  }

  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      initLuxuryScroll();
    }, 250);
  });

  document.addEventListener("shopify:section:load", initLuxuryScroll);
  document.addEventListener("shopify:section:reorder", initLuxuryScroll);
})();

